module.exports = __webpack_public_path__ + "static/media/banner-grid-04.de6d846a.jpg";